module.exports = __webpack_public_path__ + "img/DNI-ALLARIA-Dorso.6eebc75b.jpg";